import axios from 'axios'
import { AxiosRequestConfig } from 'axios'

export interface HttpResponse {
    status: number;
    headers: any;
    body: any;
}

// export const url = process.env.REACT_APP_URL || 'https://sennoapi.com';
export const url = 'https://api.xingzheng.tech';

export async function post(url: string, headers: any, body: any): Promise<HttpResponse> {

    let accessToken = localStorage.getItem('accessToken')
    let header = Object.assign({}, headers, { 'senno-access-token': accessToken || "" })

    let data: AxiosRequestConfig = {
        method: 'POST',
        headers: header,
        url: url,
        data: body,
    }
    let response = await axios(data)
    return {
        status: response.status,
        headers: response.headers,
        body: response.data,
    }
}